import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'

import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'

import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { PageTitle } from 'Components/PageTitle'

import { updateAmbassadorById } from 'Reducers/Ambassador/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { getSpy } from '../gql'

import ContactForm from '../Components/ContactForm'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import { getCities } from '../../../../../Reducers/City/actions'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'
import { theme } from '../../../../../Assets/Styles/theme'

const SpyEdit = props => {
  const { match, getCities } = props
  const {
    params: { spyId },
  } = match

  const cities = useSelector(state => state.city.citiesList)

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getSpy,
    defaultFetchArgs: { id: spyId },
  })

  useEffect(() => {
    getCities(true)
  }, [])

  if (!isLoaded) {
    return null
  }

  const { spy } = data

  const canShowContractorType =
    spy &&
    spy.city &&
    spy.city.country &&
    ['ES', 'DE'].includes(spy.city.country.code)

  const citiesOptions = cities
    ? cities.map(c => ({ label: c.name, value: c.id }))
    : []

  const spyContactDetailsFormSubmitHandler = values => {
    const { updateAmbassadorById, uploadProfileImage } = props
    const { spyId } = props.match.params

    const callbacks = {
      onSuccess: spyContactDetailsFormSubmitSuccessHandler,
    }

    const payload = imageUrl => ({
      first_name: values.firstName,
      last_name: values.lastName,
      mobile_phone: values.mobilePhone,
      city_id: values.cityId,
      business_number: values.abn,
      profile_picture: imageUrl,
      contractor_type: values.contractorType,
    })
    const imageFile = get(values, 'profilePicture[0]')
    if (imageFile && imageFile.type) {
      uploadProfileImage(spyId, imageFile, {
        onSuccess: imageUrl => {
          updateAmbassadorById(spyId, payload(imageUrl), callbacks)
        },
      })
    } else {
      updateAmbassadorById(spyId, payload(), callbacks)
    }
  }

  const spyContactDetailsFormSubmitSuccessHandler = () => {
    const { history } = props
    const cityId = spy.city.id

    history.push(
      `${PATHS.main.dashboard}${
        PATHS.dashboard.cities
      }/${cityId}/spies/${spyId}`,
    )
  }

  return (
    <AmbassadorWrapper>
      <StyledBreadcrumbs
        icon={<PinUserIcon style={{ width: 16, fill: theme.colors.primary }} />}
        breadcrumbs={[
          {
            label: 'Dashboard',
            link: `${PATHS.main.dashboard}`,
          },
          {
            label: 'Cities',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
          },
          {
            label: 'Edit Spy',
            link: props.match.url,
          },
        ]}
      />
      <PageTitle>
        {spy.firstName} {spy.lastName}
        {spy.status && <span className="status">({spy.status})</span>}
      </PageTitle>

      <AmbassadorSection>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <SectionTitle>Contact Details</SectionTitle>
            </Col>
          </Row>

          <ContactForm
            canShowContractorType={canShowContractorType}
            countryCode={spy.city ? spy.city.country.code : null}
            spy={spy}
            onSubmit={spyContactDetailsFormSubmitHandler}
            citiesOptions={citiesOptions}
            cities={cities}
            initialValues={{
              firstName: spy.firstName,
              lastName: spy.lastName,
              cityId: spy.city.id,
              mobilePhone: spy.mobilePhone,
              abn: spy.businessNumber,
              contractorType: spy.contractorType,
            }}
          />
        </Grid>
      </AmbassadorSection>
    </AmbassadorWrapper>
  )
}

export default connect(
  null,
  {
    getCities,
    updateAmbassadorById,
    uploadProfileImage,
  },
)(withRouter(SpyEdit))
